import React from 'react'

const App = () => {
  return (
    <div class='app'>
      <header>
        <a href='https://www.redbull.com'>
          <img
            src="https://resources.redbull.com/logos/redbullcom/v3/redbullcom-logo.svg"
            alt="Red Bull Logo"
            className="header-logo"
          />
        </a>
      </header>
      <video id='video' src='https://activations-redbull-com.s3.us-west-2.amazonaws.com/rb-b2b-cankas/OP_SeedingKit_EngagementVideo.mp4' controls />
      <div id='contact'>
        <p class='name'>Ritesh Purran</p>
        <p class='title'>Key Account Manager – On Premise, Eastern Canada</p>
        <a href='mailto:Ritesh.Purran@RedBull.com'><p class='email'>Ritesh.Purran@RedBull.com</p></a>
      </div>
    </div>
  )
}

export default App